import { AxiosInstance } from "axios";
import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { IntegrationTemplate } from "@/store/tasks/notification/IntegrationTemplate";
import IntegrationTemplatePagedRequest from "@/types/sv-data/integration-templates/IntegrationTemplatePagedRequest";
import IntegrationTemplatePagedResponse from "@/types/sv-data/integration-templates/IntegrationTemplatePagedResponse";

class IntegrationTemplateApi {
    private axios: AxiosInstance;
    private axiosJson: any;

    constructor() {
        this.axios = axiosInstance;
        this.axiosJson = axiosJsonInstance;
    }

    public async getIntegrationTemplates(request: IntegrationTemplatePagedRequest, groupId: number | null): Promise<IntegrationTemplatePagedResponse> {
        let query = `/IntegrationTemplate?` +
            `page=${request.page}` +
            `&pageSize=${request.pageSize}` +
            `&searchTerm=${request.searchTerm}` +
            `&sortBy=${request.sortBy}` +
            `&sortDesc=${request.sortDesc}`;

        if (groupId != null) {
            query = query + `&groupId=${groupId}`;
        }

        const { data } = await this.axiosJson.get(query);

        return data;
    }

    public async createIntegrationTemplate(integrationTemplate: IntegrationTemplate)
        : Promise<void> {
        integrationTemplate.message = this.escapeSymbols(integrationTemplate.message);

        // Parameters cannot be null, otherwise the backend will reject;
        if (integrationTemplate.parameters) {
            integrationTemplate.parameters = this.escapeSymbols(integrationTemplate.parameters);
        }
        else {
            integrationTemplate.parameters = "";
        }

        await this.axiosJson.post("/IntegrationTemplate", integrationTemplate);
    }

    public async updateIntegrationTemplate(integrationTemplate: IntegrationTemplate)
        : Promise<void> {
        integrationTemplate.message = this.escapeSymbols(integrationTemplate.message);

        // Parameters cannot be null, otherwise the backend will reject;
        if (integrationTemplate.parameters) {
            integrationTemplate.parameters = this.escapeSymbols(integrationTemplate.parameters);
        }
        else {
            integrationTemplate.parameters = "";
        }

        await this.axiosJson.put("/IntegrationTemplate", integrationTemplate);
    }

    public async deleteIntegrationTemplate(integrationTemplateId: number)
        : Promise<void> {
        await this.axios.delete(`/IntegrationTemplate/${integrationTemplateId}`);
    }

    private escapeSymbols(text: string): string {
        if (text) {
            return text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }
    }
}

const integrationTemplatesApi = new IntegrationTemplateApi();
export default integrationTemplatesApi;